import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		loadingOverlayInline_container: {
			display: 'flex',
		},
		loadingOverlayInline_circularIcon: {
			margin: '0px 10px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		loadingOverlayInline_circularProgressRoot: {
			color: 'inherit',
			fontSize: 'inherit',
			'&:hover': {

			}
		},
	});
});

export default useStyles;
